import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../contexts/UserContext";
import { MdDelete, MdAdd } from "react-icons/md";
import { FaFileUpload, FaFilePdf } from "react-icons/fa";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const S = {
  page: {
    minHeight: "100vh", background: "#f7f4f6",
    padding: "32px 16px", fontFamily: "'Segoe UI', system-ui, sans-serif",
  },
  card: {
    maxWidth: 960, margin: "0 auto", background: "#fff",
    borderRadius: 16, boxShadow: "0 2px 24px rgba(159,0,89,0.08)", overflow: "hidden",
  },
  header: {
    background: "#1d4ed8", padding: "24px 32px",
    display: "flex", alignItems: "center", justifyContent: "space-between",
  },
  headerTitle: { color: "#fff", fontSize: 22, fontWeight: 700, margin: 0 },
  headerSub: { color: "rgba(255,255,255,0.75)", fontSize: 13, marginTop: 2 },
  body: { padding: "28px 32px" },
  section: { marginBottom: 28 },
  sectionTitle: {
    fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase",
    color: "#1d4ed8", marginBottom: 12, paddingBottom: 6, borderBottom: "1.5px solid #dbeafe",
  },
  grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 },
  fieldGroup: { display: "flex", flexDirection: "column", gap: 4 },
  label: { fontSize: 12, fontWeight: 600, color: "#555", letterSpacing: "0.02em" },
  input: {
    padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8,
    fontSize: 14, color: "#121212", background: "#fafafa", outline: "none",
  },
  select: {
    padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8,
    fontSize: 14, color: "#121212", background: "#fafafa", outline: "none",
    cursor: "pointer", width: "100%",
  },
  textarea: {
    padding: "9px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8,
    fontSize: 14, color: "#121212", background: "#fafafa", outline: "none",
    resize: "vertical", minHeight: 72, fontFamily: "inherit",
    width: "100%", boxSizing: "border-box",
  },
  tableWrap: { border: "1.5px solid #dbeafe", borderRadius: 10, overflow: "hidden" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: {
    background: "#eff6ff", padding: "10px 12px", fontSize: 11, fontWeight: 700,
    letterSpacing: "0.08em", textTransform: "uppercase", color: "#1d4ed8",
    textAlign: "left", borderBottom: "1.5px solid #dbeafe",
  },
  td: { padding: "8px 10px", borderBottom: "1px solid #f0f4ff", verticalAlign: "middle" },
  tdInput: {
    padding: "6px 8px", border: "1.5px solid #e0d6dc", borderRadius: 6,
    fontSize: 13, width: "100%", background: "#fff", boxSizing: "border-box",
    outline: "none", color: "#121212",
  },
  addRowBtn: {
    display: "flex", alignItems: "center", gap: 6, padding: "10px 16px",
    background: "transparent", border: "1.5px dashed #93c5fd", borderRadius: 8,
    color: "#1d4ed8", fontSize: 13, fontWeight: 600, cursor: "pointer", marginTop: 10,
  },
  deleteBtn: {
    background: "none", border: "none", color: "#c0396a", cursor: "pointer",
    padding: 4, display: "flex", alignItems: "center", borderRadius: 4,
  },
  ocZoneRequired: {
    border: "2px solid #1d4ed8", borderRadius: 10, padding: "18px 20px",
    cursor: "pointer", display: "flex", alignItems: "center", gap: 12,
    color: "#1d4ed8", fontSize: 14, fontWeight: 600, background: "#eff6ff",
  },
  ocZoneOk: {
    border: "2px solid #16a34a", borderRadius: 10, padding: "18px 20px",
    display: "flex", alignItems: "center", gap: 12,
    color: "#166534", fontSize: 14, fontWeight: 600, background: "#f0fdf4",
  },
  fileZone: {
    border: "1.5px dashed #93c5fd", borderRadius: 10, padding: "14px 20px",
    cursor: "pointer", display: "flex", alignItems: "center", gap: 10,
    color: "#1d4ed8", fontSize: 13, fontWeight: 600, background: "#f8fbff",
  },
  fileList: { display: "flex", flexWrap: "wrap", gap: 8, marginTop: 10 },
  fileChip: {
    display: "flex", alignItems: "center", gap: 6, padding: "4px 10px",
    background: "#dbeafe", borderRadius: 20, fontSize: 12, color: "#1d4ed8", fontWeight: 500,
  },
  footer: {
    padding: "20px 32px", background: "#eff6ff", borderTop: "1.5px solid #dbeafe",
    display: "flex", alignItems: "center", justifyContent: "space-between",
  },
  total: { fontSize: 20, fontWeight: 700, color: "#1d4ed8" },
  totalLabel: { fontSize: 12, color: "#888", marginBottom: 2 },
  btnPrimary: {
    padding: "11px 28px", background: "#1d4ed8", color: "#fff", border: "none",
    borderRadius: 9, fontSize: 15, fontWeight: 700, cursor: "pointer",
  },
  btnSecondary: {
    padding: "11px 22px", background: "transparent", color: "#1d4ed8",
    border: "1.5px solid #93c5fd", borderRadius: 9, fontSize: 14,
    fontWeight: 600, cursor: "pointer", marginRight: 10,
  },
  // Bundle-specific
  bundleHeader: {
    background: "#1d4ed8", color: "#fff", padding: "8px 14px",
    borderRadius: "8px 8px 0 0", fontSize: 12, fontWeight: 700,
    display: "flex", alignItems: "center", justifyContent: "space-between",
  },
  bundleWrap: {
    border: "1.5px solid #1d4ed8", borderRadius: 8, marginBottom: 16, overflow: "hidden",
  },
  bundleTableWrap: { borderTop: "none", overflow: "hidden" },
  bundleAddRow: {
    display: "flex", alignItems: "center", gap: 6, padding: "8px 14px",
    background: "#eff6ff", border: "none", borderTop: "1px dashed #93c5fd",
    color: "#1d4ed8", fontSize: 12, fontWeight: 600, cursor: "pointer", width: "100%",
    textAlign: "left",
  },
};

const uid = () => Math.random().toString(36).slice(2);

const emptyItem = () => ({
  _key: uid(), category: "", description: "", quantity: "", price: "", number: "", observations: "",
});

const emptyBundle = (fecha = "") => ({ _key: uid(), fecha_entrega: fecha, items: [emptyItem()] });

const formatBundleDate = (d) => {
  if (!d) return "Sin fecha";
  try {
    return new Date(d + "T00:00:00").toLocaleDateString("es-AR", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return d; }
};

// ── Fila de producto — definida FUERA del componente para evitar remount en cada render ──
const ItemRow = ({ it, categories, onUpdate, onRemove, showRemove }) => (
  <tr>
    <td style={{ ...S.td, minWidth: 140 }}>
      <select style={{ ...S.tdInput, minWidth: 130 }} value={it.category}
        onChange={(e) => onUpdate(it._key, "category", e.target.value)}>
        <option value="">Categoría</option>
        {categories.map((c) => <option key={c.id} value={c.id}>{c.categoria}</option>)}
      </select>
    </td>
    <td style={{ ...S.td, minWidth: 180 }}>
      <input style={{ ...S.tdInput, minWidth: 170 }} type="text"
        placeholder="Descripción del producto" value={it.description}
        onChange={(e) => onUpdate(it._key, "description", e.target.value)} />
    </td>
    <td style={{ ...S.td, width: 90 }}>
      <input style={{ ...S.tdInput, width: 60 }} type="number" min="0"
        placeholder="0" value={it.quantity}
        onChange={(e) => onUpdate(it._key, "quantity", e.target.value)} />
    </td>
    <td style={{ ...S.td, width: 90 }}>
      <input style={{ ...S.tdInput, width: 80 }} type="number" min="0" step="0.01"
        placeholder="0.00" value={it.price}
        onChange={(e) => onUpdate(it._key, "price", e.target.value)} />
    </td>
    <td style={{ ...S.td, width: 100 }}>
      <input style={{ ...S.tdInput, width: 90 }} type="text"
        placeholder="—" value={it.number}
        onChange={(e) => onUpdate(it._key, "number", e.target.value)} />
    </td>
    <td style={{ ...S.td, minWidth: 120 }}>
      <input style={{ ...S.tdInput, minWidth: 110 }} type="text"
        placeholder="Notas..." value={it.observations}
        onChange={(e) => onUpdate(it._key, "observations", e.target.value)} />
    </td>
    <td style={{ ...S.td, width: 36 }}>
      {showRemove && (
        <button style={S.deleteBtn} onClick={() => onRemove(it._key)}>
          <MdDelete size={18} />
        </button>
      )}
    </td>
  </tr>
);

const NuevaOrdenCompra = () => {
  const { user } = useContext(UserContext);
  const history  = useHistory();

  const [preload] = useState(() => {
    try { const raw = sessionStorage.getItem("nueva_oc_preload"); if (raw) return JSON.parse(raw); } catch {}
    return {};
  });
  useEffect(() => { sessionStorage.removeItem("nueva_oc_preload"); }, []);

  const [clients, setClients]       = useState([]);
  const [providers, setProviders]   = useState([]);
  const [categories, setCategories] = useState([]);
  const [contacts, setContacts]     = useState([]);

  const [inputClient,   setInputClient]   = useState(preload.clienteId   ? String(preload.clienteId)   : "");
  const [inputProvider, setInputProvider] = useState(preload.proveedorId ? String(preload.proveedorId) : "");
  const [inputContact,  setInputContact]  = useState(preload.contactoId  ? String(preload.contactoId)  : "");
  const [inputObs,      setInputObs]      = useState("");
  const [inputNumeroOC, setInputNumeroOC] = useState("");
  const [ocFile,        setOcFile]        = useState(null);
  const [extraFiles,    setExtraFiles]    = useState([]);
  const [submitting,    setSubmitting]    = useState(false);
  const [loading,       setLoading]       = useState(!!preload.plantillaId);
  const [extrayendo,    setExtrayendo]    = useState(false);
  const [extractedFields, setExtractedFields] = useState(new Set());

  // ── Estado de entregas ────────────────────────────────────────────────────
  const [entregasMultiples, setEntregasMultiples] = useState(false);
  const [fechaEntrega,      setFechaEntrega]      = useState("");
  // Modo simple: lista plana de items
  const [items, setItems] = useState([emptyItem()]);
  // Modo bundles: array de { _key, fecha_entrega, items[] }
  const [bundles, setBundles] = useState([]);

  // ── Estado de moneda ──────────────────────────────────────────────────────
  const [moneda,     setMoneda]     = useState("ARS");
  const [tipoCambio, setTipoCambio] = useState("");
  const [loadingTC,  setLoadingTC]  = useState(false);
  const [tcFecha,    setTcFecha]    = useState("");

  // ── Cargar listas base ────────────────────────────────────────────────────
  useEffect(() => {
    axios.post(`${BASE}/buscar_terceros.php`).then((r) => {
      setClients(r.data.filter((x) => x.tipo_other === 2));
      setProviders(r.data.filter((x) => x.tipo_other === 3));
    });
    axios.post(`${BASE}/buscar_categorias.php`).then((r) => setCategories(r.data));
  }, []);

  useEffect(() => {
    if (!inputClient) { setContacts([]); if (!preload.contactoId) setInputContact(""); return; }
    axios.post(`${BASE}/crm_contactos_listar.php`, new URLSearchParams({ cliente_id: inputClient }))
      .then((r) => setContacts(Array.isArray(r.data) ? r.data : []))
      .catch(() => setContacts([]));
  }, [inputClient]);

  useEffect(() => {
    if (!preload.plantillaId) { setLoading(false); return; }
    axios.post(`${BASE}/buscar_items_plantilla.php`, new URLSearchParams({ orden_id: preload.plantillaId }))
      .then((r) => {
        const list = Array.isArray(r.data) ? r.data : [];
        if (list.length > 0) {
          setItems(list.map((it) => ({
            _key: uid(), category: String(it.category ?? ""), description: it.description ?? "",
            quantity: String(it.quantity ?? ""), price: String(it.price ?? ""),
            number: it.number ?? "", observations: it.observations ?? "",
          })));
        }
        if (preload.proveedorId) setInputProvider(String(preload.proveedorId));
        if (preload.observaciones) setInputObs(preload.observaciones);
      })
      .catch(() => toast.error("No se pudo cargar la plantilla."))
      .finally(() => setLoading(false));
  }, [preload.plantillaId]);

  // ── Helpers modo simple ───────────────────────────────────────────────────
  const updateItem = (key, field, val) =>
    setItems((prev) => prev.map((it) => it._key === key ? { ...it, [field]: val } : it));
  const addItem    = () => setItems((p) => [...p, emptyItem()]);
  const removeItem = (key) => setItems((p) => p.filter((it) => it._key !== key));

  // ── Helpers modo bundles ──────────────────────────────────────────────────
  const addBundle    = () => setBundles((p) => [...p, emptyBundle()]);
  const removeBundle = (key) => setBundles((p) => p.length > 1 ? p.filter((b) => b._key !== key) : p);
  const updateBundle = (key, field, val) =>
    setBundles((p) => p.map((b) => b._key === key ? { ...b, [field]: val } : b));
  const addBundleItem    = (bKey) =>
    setBundles((p) => p.map((b) => b._key === bKey ? { ...b, items: [...b.items, emptyItem()] } : b));
  const removeBundleItem = (bKey, iKey) =>
    setBundles((p) => p.map((b) => b._key !== bKey ? b :
      { ...b, items: b.items.length > 1 ? b.items.filter((it) => it._key !== iKey) : b.items }));
  const updateBundleItem = (bKey, iKey, field, val) =>
    setBundles((p) => p.map((b) => b._key !== bKey ? b :
      { ...b, items: b.items.map((it) => it._key === iKey ? { ...it, [field]: val } : it) }));

  // ── Toggle entregas múltiples ─────────────────────────────────────────────
  const toggleEntregasMultiples = () => {
    if (!entregasMultiples) {
      // Activar: mover items actuales al primer bundle
      const fecha = fechaEntrega || "";
      const bundleItems = items.map((it) => ({ ...it, _key: uid() }));
      setBundles([{ _key: uid(), fecha_entrega: fecha, items: bundleItems.length ? bundleItems : [emptyItem()] }]);
    } else {
      // Desactivar: aplanar todos los items del primer bundle
      const allItems = bundles.flatMap((b) => b.items.map((it) => ({ ...it, _key: uid() })));
      setItems(allItems.length ? allItems : [emptyItem()]);
      if (bundles.length > 0 && bundles[0].fecha_entrega) setFechaEntrega(bundles[0].fecha_entrega);
    }
    setEntregasMultiples((p) => !p);
  };

  // ── Tipo de cambio BNA ────────────────────────────────────────────────────
  const fetchTipoCambio = async () => {
    setLoadingTC(true);
    try {
      const r = await axios.get(`${BASE}/get_tipo_cambio_bna.php`);
      if (r.data?.success) {
        setTipoCambio(String(r.data.venta));
        setTcFecha(r.data.fecha);
      } else {
        toast.error(r.data?.mensaje || "No se pudo obtener el tipo de cambio.");
      }
    } catch {
      toast.error("Error al consultar el tipo de cambio BNA.");
    } finally {
      setLoadingTC(false);
    }
  };

  const handleMonedaChange = (newMoneda) => {
    setMoneda(newMoneda);
    if (newMoneda === "USD" && !tipoCambio) fetchTipoCambio();
    if (newMoneda === "ARS") { setTipoCambio(""); setTcFecha(""); }
  };

  // ── IA helpers ────────────────────────────────────────────────────────────
  const clearExtracted = (field) =>
    setExtractedFields((prev) => { const n = new Set(prev); n.delete(field); return n; });
  const aiStyle = (field) =>
    extractedFields.has(field) ? { outline: "2px solid #16a34a", borderColor: "#16a34a" } : {};

  const handleExtraer = async () => {
    if (!ocFile) return;
    setExtrayendo(true);
    try {
      const fd = new FormData();
      fd.append("archivo", ocFile);
      const res = await axios.post(`${BASE}/extraer_orden.php`, fd);
      const { ok, extraido, error: errMsg } = res.data;
      if (!ok) throw new Error(errMsg || "Error desconocido");
      const filled = new Set();
      if (extraido.cliente_id_sugerido) { setInputClient(String(extraido.cliente_id_sugerido)); setInputContact(""); filled.add("cliente"); }
      if (extraido.fecha_entrega)       { setFechaEntrega(extraido.fecha_entrega); filled.add("fechaEntrega"); }
      if (extraido.notas)               { setInputObs(extraido.notas); filled.add("obs"); }
      if (extraido.numero_oc_cliente)   { setInputNumeroOC(extraido.numero_oc_cliente); filled.add("numeroOC"); }
      if (extraido.items?.length > 0) {
        const newItems = extraido.items.map((it) => ({
          _key: uid(), category: String(it.categoria_id_sugerida ?? ""),
          description: it.descripcion ?? "", quantity: String(it.cantidad ?? ""),
          price: String(it.precio_unitario ?? ""), number: "", observations: "",
        }));
        if (entregasMultiples && bundles.length > 0) {
          // Poner items extraídos en el primer bundle
          setBundles((p) => p.map((b, i) => i === 0 ? { ...b, items: newItems } : b));
        } else {
          setItems(newItems);
        }
        filled.add("items");
      }
      setExtractedFields(filled);
      if (extraido.confianza === "baja") toast.warning("Extracción con baja confianza — revisá los datos");
      else toast.success(`Datos extraídos (confianza: ${extraido.confianza}) — revisá y confirmá`);
    } catch (err) {
      toast.error("Error al extraer datos: " + err.message);
    } finally {
      setExtrayendo(false);
    }
  };

  // ── Total ─────────────────────────────────────────────────────────────────
  const total = entregasMultiples
    ? bundles.reduce((sum, b) =>
        sum + b.items.reduce((s, it) => s + (parseFloat(it.quantity) || 0) * (parseFloat(it.price) || 0), 0), 0)
        .toFixed(2)
    : items.reduce((s, it) => s + (parseFloat(it.quantity) || 0) * (parseFloat(it.price) || 0), 0).toFixed(2);

  // ── Validación ────────────────────────────────────────────────────────────
  const validate = () => {
    if (!inputClient || !inputProvider) { toast.error("Seleccioná cliente y proveedor."); return false; }
    if (!inputContact) { toast.error("Seleccioná un contacto."); return false; }
    if (!ocFile)       { toast.error("Adjuntá el archivo de Orden de Compra."); return false; }
    if (entregasMultiples) {
      if (bundles.length === 0) { toast.error("Agregá al menos un bundle de entrega."); return false; }
      for (const b of bundles) {
        if (!b.fecha_entrega) { toast.error("Todos los bundles necesitan fecha de entrega."); return false; }
        const validItems = b.items.filter((it) => it.description.trim() && it.quantity && it.category);
        if (validItems.length === 0) {
          toast.error(`Bundle ${formatBundleDate(b.fecha_entrega)}: agregá al menos un producto válido.`);
          return false;
        }
      }
    } else {
      if (!fechaEntrega) { toast.error("La fecha de entrega es obligatoria."); return false; }
      const valid = items.filter((it) => it.description.trim() && it.quantity && it.category);
      if (valid.length === 0) { toast.error("Agregá al menos un producto con categoría, descripción y cantidad."); return false; }
    }
    return true;
  };

  // ── Submit ────────────────────────────────────────────────────────────────
  const handleSubmit = async () => {
    if (!validate()) return;
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("cliente_id",       inputClient);
      fd.append("proveedor_id",     inputProvider);
      fd.append("contacto_id",      inputContact);
      fd.append("observaciones",    inputObs);
      fd.append("numero_oc_externo", inputNumeroOC);
      fd.append("user_id",          user.id);
      fd.append("ordenCompra",      ocFile);
      fd.append("totalAmount",      total);
      fd.append("moneda",           moneda);
      fd.append("tipo_cambio",      moneda === "USD" ? tipoCambio : "");
      extraFiles.forEach((f, i) => fd.append(`file_${i}`, f));

      if (entregasMultiples) {
        const minFecha = bundles.map((b) => b.fecha_entrega).filter(Boolean).sort()[0] || "";
        fd.append("entregasMultiples", "1");
        fd.append("fechaEntrega", minFecha);
        const bundlesData = bundles.map((b) => ({
          fecha_entrega: b.fecha_entrega,
          items: b.items
            .filter((it) => it.description.trim() && it.quantity && it.category)
            .map((it) => ({
              quantity:     parseFloat(it.quantity),
              price:        parseFloat(it.price) || 0,
              description:  it.description,
              number:       it.number,
              observations: it.observations,
              category:     it.category,
            })),
        }));
        fd.append("bundles", JSON.stringify(bundlesData));
      } else {
        const orderItems = items
          .filter((it) => it.description.trim() && it.quantity && it.category)
          .map((it) => ({
            quantity: parseFloat(it.quantity), price: parseFloat(it.price) || 0,
            description: it.description, number: it.number,
            observations: it.observations, category: it.category,
          }));
        fd.append("entregasMultiples", "0");
        fd.append("fechaEntrega", fechaEntrega);
        fd.append("orderItems", JSON.stringify(orderItems));
      }

      const res = await axios.post(`${BASE}/crear_oc_directa.php`, fd);
      if (res.data.success) {
        toast.success("✅ Orden de compra creada. Ingresó al seguimiento.");
        history.push("/dashboard/seguimiento");
      } else {
        toast.error(res.data.message || "Error al crear la OC.");
      }
    } catch {
      toast.error("Error de conexión.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return (
    <section style={S.page}><div style={S.card}>
      <div style={S.header}><h2 style={S.headerTitle}>Nueva Orden de Compra</h2></div>
      <p style={{ textAlign: "center", padding: 48, color: "#aaa" }}>Cargando plantilla…</p>
    </div></section>
  );

  const tableHeaders = ["Categoría", "Descripción", "Cant.", "Precio", "N° Plano", "Obs.", ""];

  return (
    <section style={S.page}>
      <div style={S.card}>
        <div style={S.header}>
          <div>
            <h2 style={S.headerTitle}>📋 Nueva Orden de Compra</h2>
            <p style={S.headerSub}>
              {preload.plantillaId
                ? `Plantilla desde Orden #${preload.plantillaId} — podés modificar todo`
                : "Completá los datos y adjuntá la OC del cliente"}
            </p>
          </div>
        </div>

        <div style={S.body}>
          {/* ── Datos generales ── */}
          <div style={S.section}>
            <p style={S.sectionTitle}>Datos generales</p>
            <div style={S.grid2}>
              <div style={S.fieldGroup}>
                <label style={S.label}>Cliente</label>
                <select style={{ ...S.select, ...aiStyle("cliente") }} value={inputClient}
                  onChange={(e) => { setInputClient(e.target.value); setInputContact(""); clearExtracted("cliente"); }}>
                  <option value="">Seleccioná un cliente</option>
                  {clients.map((c) => <option key={c.id} value={c.id}>{c.tercero}</option>)}
                </select>
              </div>
              <div style={S.fieldGroup}>
                <label style={S.label}>Proveedor</label>
                <select style={S.select} value={inputProvider}
                  onChange={(e) => setInputProvider(e.target.value)}>
                  <option value="">Seleccioná un proveedor</option>
                  {providers.map((p) => <option key={p.id} value={p.id}>{p.tercero}</option>)}
                </select>
              </div>
            </div>

            <div style={{ ...S.fieldGroup, marginTop: 16 }}>
              <label style={S.label}>
                Contacto *
                {inputClient && contacts.length === 0 && (
                  <span style={{ color: "#f59e0b", fontWeight: 400, marginLeft: 8 }}>
                    — Este cliente no tiene contactos en el CRM
                  </span>
                )}
              </label>
              <select
                style={{ ...S.select, borderColor: !inputContact && inputClient ? "#f59e0b" : "#e0d6dc" }}
                value={inputContact}
                onChange={(e) => setInputContact(e.target.value)}
                disabled={!inputClient || contacts.length === 0}
              >
                <option value="">
                  {!inputClient ? "Primero seleccioná un cliente" : contacts.length === 0 ? "Sin contactos disponibles" : "Seleccioná un contacto"}
                </option>
                {contacts.map((c) => (
                  <option key={c.id} value={c.id}>{c.nombre}{c.cargo ? ` — ${c.cargo}` : ""}</option>
                ))}
              </select>
            </div>

            {/* Moneda y tipo de cambio */}
            <div style={{ marginTop: 16 }}>
              <label style={S.label}>Moneda</label>
              <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                {["ARS", "USD"].map((m) => (
                  <button
                    key={m}
                    type="button"
                    onClick={() => handleMonedaChange(m)}
                    style={{
                      padding: "7px 20px", borderRadius: 7, fontWeight: 700, fontSize: 13,
                      cursor: "pointer", border: "1.5px solid",
                      background: moneda === m ? (m === "USD" ? "#fffbeb" : "#eff6ff") : "#fff",
                      borderColor: moneda === m ? (m === "USD" ? "#f59e0b" : "#1d4ed8") : "#e0d6dc",
                      color: moneda === m ? (m === "USD" ? "#92400e" : "#1d4ed8") : "#555",
                    }}
                  >
                    {m === "ARS" ? "$ ARS" : "U$D USD"}
                  </button>
                ))}
              </div>
              {moneda === "USD" && (
                <div style={{ marginTop: 10, padding: "12px 14px", background: "#fffbeb", borderRadius: 8, border: "1.5px solid #fcd34d" }}>
                  <label style={{ ...S.label, color: "#92400e" }}>Tipo de cambio BNA vendedor (editable)</label>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 4 }}>
                    <span style={{ fontSize: 14, color: "#92400e", fontWeight: 600 }}>$</span>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="Ej: 1035.50"
                      value={tipoCambio}
                      onChange={(e) => setTipoCambio(e.target.value)}
                      style={{ ...S.input, width: 130, borderColor: "#fcd34d", background: "#fff" }}
                    />
                    <button
                      type="button"
                      onClick={fetchTipoCambio}
                      disabled={loadingTC}
                      style={{
                        padding: "7px 14px", borderRadius: 7, fontSize: 12, fontWeight: 700,
                        cursor: loadingTC ? "default" : "pointer",
                        background: loadingTC ? "#f0e6ec" : "#1d4ed8", color: loadingTC ? "#bbb" : "#fff",
                        border: "none",
                      }}
                    >
                      {loadingTC ? "Cargando…" : "↻ Actualizar"}
                    </button>
                  </div>
                  {tcFecha && (
                    <div style={{ fontSize: 11, color: "#92400e", marginTop: 5, opacity: 0.8 }}>
                      BNA vendedor {tcFecha} — actualizado automáticamente
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Fecha de entrega + toggle entregas múltiples */}
            <div style={{ marginTop: 16 }}>
              <label style={S.label}>Fecha de entrega *</label>
              <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 4, flexWrap: "wrap" }}>
                {!entregasMultiples && (
                  <input
                    style={{ ...S.input, ...aiStyle("fechaEntrega"), width: 200 }}
                    type="date"
                    value={fechaEntrega}
                    onChange={(e) => { setFechaEntrega(e.target.value); clearExtracted("fechaEntrega"); }}
                  />
                )}
                <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: 13, color: "#374151", userSelect: "none" }}>
                  <input
                    type="checkbox"
                    checked={entregasMultiples}
                    onChange={toggleEntregasMultiples}
                    style={{ width: 14, height: 14, cursor: "pointer" }}
                  />
                  <strong>Entregas múltiples</strong>
                </label>
              </div>

              {entregasMultiples && (
                <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 8 }}>
                  {bundles.map((b, idx) => (
                    <div key={b._key} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ fontSize: 12, color: "#1d4ed8", fontWeight: 700, minWidth: 72 }}>
                        📅 Bundle {idx + 1}:
                      </span>
                      <input
                        type="date"
                        style={{ ...S.input, width: 180, borderColor: !b.fecha_entrega ? "#f59e0b" : "#e0d6dc" }}
                        value={b.fecha_entrega}
                        onChange={(e) => updateBundle(b._key, "fecha_entrega", e.target.value)}
                      />
                      {bundles.length > 1 && (
                        <button
                          onClick={() => removeBundle(b._key)}
                          style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 16, padding: 2 }}
                          title="Eliminar bundle"
                        >✕</button>
                      )}
                    </div>
                  ))}
                  <button style={{ ...S.addRowBtn, marginTop: 2, padding: "6px 14px", fontSize: 12, width: "fit-content" }}
                    onClick={addBundle}>
                    <MdAdd size={14} /> Agregar bundle
                  </button>
                </div>
              )}
            </div>

            <div style={{ marginTop: 16 }}>
              <label style={S.label}>Nº OC del cliente</label>
              <input
                style={{ ...S.input, ...aiStyle("numeroOC"), width: "100%", boxSizing: "border-box" }}
                type="text" placeholder="Ej: OC-2024-1234 (opcional)"
                value={inputNumeroOC}
                onChange={(e) => { setInputNumeroOC(e.target.value); clearExtracted("numeroOC"); }}
              />
            </div>

            <div style={{ marginTop: 16 }}>
              <label style={S.label}>Observaciones</label>
              <textarea style={{ ...S.textarea, ...aiStyle("obs") }} placeholder="Notas adicionales…"
                value={inputObs} onChange={(e) => { setInputObs(e.target.value); clearExtracted("obs"); }} />
            </div>
          </div>

          {/* ── Orden de Compra del cliente ── */}
          <div style={S.section}>
            <p style={S.sectionTitle}>Orden de Compra del cliente *</p>
            {ocFile ? (
              <div style={S.ocZoneOk}>
                <FaFilePdf size={22} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700 }}>{ocFile.name}</div>
                  <div style={{ fontSize: 12, opacity: 0.7 }}>{(ocFile.size / 1024).toFixed(1)} KB</div>
                </div>
                <button onClick={handleExtraer} disabled={extrayendo}
                  style={{ background: extrayendo ? "#d1d5db" : "#9F0059", border: "none", color: "#fff",
                    cursor: extrayendo ? "default" : "pointer", fontSize: 13, fontWeight: 700,
                    padding: "7px 16px", borderRadius: 7, marginRight: 8 }}>
                  {extrayendo ? "Extrayendo…" : "✨ Extraer datos"}
                </button>
                <button onClick={() => setOcFile(null)}
                  style={{ background: "none", border: "none", color: "#dc2626", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>
                  Cambiar
                </button>
              </div>
            ) : (
              <label style={S.ocZoneRequired}>
                <FaFileUpload size={22} />
                <span>Adjuntar OC del cliente (PDF, imagen) — obligatorio</span>
                <input type="file" accept=".pdf,.png,.jpg,.jpeg" style={{ display: "none" }}
                  onChange={(e) => e.target.files[0] && setOcFile(e.target.files[0])} />
              </label>
            )}
          </div>

          {/* ── Productos ── */}
          <div style={S.section}>
            <p style={S.sectionTitle}>Productos</p>
            {extractedFields.has("items") && (
              <div style={{ marginBottom: 10, padding: "6px 14px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 6, fontSize: 12, color: "#166534", fontWeight: 600 }}>
                ✨ Productos precargados por IA — revisá descripciones, cantidades y precios antes de guardar
              </div>
            )}

            {entregasMultiples ? (
              // ── Modo bundles ─────────────────────────────────────────────
              <div>
                {bundles.map((b, bidx) => (
                  <div key={b._key} style={S.bundleWrap}>
                    <div style={S.bundleHeader}>
                      <span>📅 Bundle {bidx + 1} — {formatBundleDate(b.fecha_entrega)}</span>
                    </div>
                    <table style={S.table}>
                      <thead>
                        <tr>{tableHeaders.map((h) => <th key={h} style={S.th}>{h}</th>)}</tr>
                      </thead>
                      <tbody>
                        {b.items.map((it) => (
                          <ItemRow
                            key={it._key} it={it}
                            categories={categories}
                            onUpdate={(key, field, val) => updateBundleItem(b._key, key, field, val)}
                            onRemove={(key) => removeBundleItem(b._key, key)}
                            showRemove={b.items.length > 1}
                          />
                        ))}
                      </tbody>
                    </table>
                    <button style={S.bundleAddRow} onClick={() => addBundleItem(b._key)}>
                      <MdAdd size={14} style={{ marginRight: 4 }} />
                      Agregar producto a Bundle {bidx + 1}
                    </button>
                  </div>
                ))}
                <button style={{ ...S.addRowBtn, marginTop: 4 }} onClick={addBundle}>
                  <MdAdd size={16} /> Nuevo bundle
                </button>
              </div>
            ) : (
              // ── Modo entrega única ────────────────────────────────────────
              <div>
                <div style={S.tableWrap}>
                  <table style={S.table}>
                    <thead>
                      <tr>{tableHeaders.map((h) => <th key={h} style={S.th}>{h}</th>)}</tr>
                    </thead>
                    <tbody>
                      {items.map((it) => (
                        <ItemRow
                          key={it._key} it={it}
                          categories={categories}
                          onUpdate={updateItem}
                          onRemove={removeItem}
                          showRemove={items.length > 1}
                        />
                      ))}
                    </tbody>
                  </table>
                </div>
                <button style={S.addRowBtn} onClick={addItem}>
                  <MdAdd size={16} /> Agregar producto
                </button>
              </div>
            )}
          </div>

          {/* ── Archivos adicionales ── */}
          <div style={S.section}>
            <p style={S.sectionTitle}>Archivos adicionales</p>
            <label style={S.fileZone}>
              <FaFileUpload size={18} />
              <span>Subir archivos extra (planos, especificaciones…)</span>
              <input type="file" multiple style={{ display: "none" }}
                onChange={(e) => setExtraFiles((p) => [...p, ...Array.from(e.target.files)])} />
            </label>
            {extraFiles.length > 0 && (
              <div style={S.fileList}>
                {extraFiles.map((f, i) => (
                  <span key={i} style={S.fileChip}>
                    {f.name}
                    <button onClick={() => setExtraFiles((p) => p.filter((_, j) => j !== i))}
                      style={{ background: "none", border: "none", color: "#1d4ed8", cursor: "pointer", padding: 0, fontSize: 14, lineHeight: 1 }}>
                      ×
                    </button>
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={S.footer}>
          <div>
            <div style={S.totalLabel}>Total estimado</div>
            <div style={S.total}>
              {moneda === "USD" ? "USD " : "$"}
              {parseFloat(total).toLocaleString("es-AR", { minimumFractionDigits: 2 })}
            </div>
            {moneda === "USD" && tipoCambio && parseFloat(tipoCambio) > 0 && (
              <div style={{ fontSize: 12, color: "#92400e", marginTop: 2 }}>
                ≈ ${(parseFloat(total) * parseFloat(tipoCambio)).toLocaleString("es-AR", { minimumFractionDigits: 0 })} ARS
              </div>
            )}
          </div>
          <div>
            <button style={S.btnSecondary} onClick={() => history.goBack()} disabled={submitting}>
              Cancelar
            </button>
            <button style={S.btnPrimary} onClick={handleSubmit} disabled={submitting}>
              {submitting ? "Creando…" : "Crear Orden de Compra"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NuevaOrdenCompra;
